import { toObjectMap } from "@@/utilities/dictionary";
import type { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { faMemo as faMemoDraft } from "@fortawesome/pro-light-svg-icons";
import { faMemo, faMemoCircleCheck } from "@fortawesome/pro-regular-svg-icons";
import { z } from "zod";
import type { TranslatableValue} from "../translations/translation";
import { translation } from "../translations/translation";

const pageStates = ["draft", "published", "unpublished"] as const;
type PageState = (typeof pageStates)[number];
const pageState = toObjectMap<PageState>([...pageStates]);
const pageStateZodSchema = z.enum(pageStates);

const pageStateName: Record<PageState, TranslatableValue> = {
    draft: translation({
        en: "Draft",
        sv: "Utkast",
    }),
    published: translation({
        sv: "Publicerad",
        en: "Published",
    }),
    unpublished: translation({
        en: "Unpublished",
        sv: "Opublicerad",
    }),
} as const;
const pageStateIcon: Record<PageState, IconDefinition> = {
    draft: faMemoDraft,
    published: faMemoCircleCheck,
    unpublished: faMemo,
} as const;

export {
    pageState,
    pageStateIcon,
    pageStateName,
    pageStateZodSchema,
    pageStates,
};
export type { PageState };
